/**
 * Reportes Avanzados API Service
 * Libro Mayor, Balance de Comprobacion, Flujo de Caja Real, Presupuesto vs Real
 */
import api from './api';

const API_BASE_URL = (() => {
  const baseURL = api?.defaults?.baseURL || '/api/content';
  return baseURL.replace(/\/content\/?$/i, '/contabilidad');
})();

const reportesAvanzadosService = {
  getLibroMayor: (filters = {}) => api.get(`${API_BASE_URL}/reportes/libro-mayor/`, { params: filters }),
  getBalanceComprobacion: (filters = {}) => api.get(`${API_BASE_URL}/reportes/balance-comprobacion/`, { params: filters }),
  getFlujoCajaReal: (filters = {}) => api.get(`${API_BASE_URL}/reportes/flujo-caja-real/`, { params: filters }),
  getPresupuestoVsReal: (filters = {}) => api.get(`${API_BASE_URL}/reportes/presupuesto-vs-real/`, { params: filters }),
  getRentabilidadCentroCosto: (filters = {}) => api.get(`${API_BASE_URL}/reportes/rentabilidad-centro-costo/`, { params: filters }),
  getReporteActivosFijos: (filters = {}) => api.get(`${API_BASE_URL}/reportes/activos-fijos/`, { params: filters }),
  getReporteViaticos: (filters = {}) => api.get(`${API_BASE_URL}/reportes/viaticos/`, { params: filters }),
};

export default reportesAvanzadosService;
